/**
 * CSRF is NOT part of this app's API security model: the API authenticates with
 * stateless JWT (Authorization header, not cookies), and the public marketing
 * endpoints (contact / demo / trial-signup) are AllowAny + reCAPTCHA-gated.
 * DRF's JWTAuthentication does not enforce CSRF, and `CSRF_COOKIE_HTTPONLY=True`
 * means JS can never read the `csrftoken` cookie anyway.
 *
 * This hook used to mint a fake `Math.random()` token and log it to the console,
 * implying a protection that doesn't exist. It is kept only as a thin, honest
 * shim so the existing form components keep their interface; it no longer
 * fabricates a token. If a real `csrftoken` cookie is ever present it is read,
 * otherwise no token / header is produced.
 */
import { useMemo } from 'react';

export const getCookie = (name) => {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
};

export const useCsrfFormSecurity = () => useMemo(() => ({
  csrfToken: getCookie('csrftoken'),
  isCsrfReady: true,
  isLoading: false,
  ensureTokenIsPresent: async () => true,
  getCsrfHeader: () => {
    const token = getCookie('csrftoken');
    return token ? { 'X-CSRFToken': token } : {};
  },
  regenerateToken: () => {},
}), []);
